import { DTOError } from 'src/error/errors/DTOError';

import type { OrderExtra } from './types';

export const orderExtrasDTO = (data: unknown): OrderExtra[] => {
  if (!data || !Array.isArray(data)) {
    throw new DTOError('orderExtrasDTO', data);
  }

  return data.map((orderExtraData) => orderExtraDTO(orderExtraData));
};

const orderExtraDTO = (data: unknown): OrderExtra => {
  if (
    !data ||
    typeof data !== 'object' ||
    !('name' in data) ||
    typeof data.name !== 'string' ||
    !('code_name' in data) ||
    typeof data.code_name !== 'string'
  ) {
    throw new DTOError('orderExtraDTO', data);
  }

  return {
    name: data.name,
    code_name: data.code_name,
    price:
      'price' in data && typeof data.price === 'number'
        ? data.price
        : undefined,
    mandatory:
      'mandatory' in data && typeof data.mandatory === 'boolean'
        ? data.mandatory
        : undefined,
    description:
      'description' in data && typeof data.description === 'string'
        ? data.description
        : undefined,
    tooltip:
      'tooltip' in data && typeof data.tooltip === 'string'
        ? data.tooltip
        : undefined,
  };
};
